module.exports = __webpack_public_path__ + "img/delete-doc.aa1653ae.svg";